'use strict';

var hasKey = require('../iterable/hasKey');

module.exports = function (fn) {
  var cache = {};
  return function (input) {
    if (hasKey(cache, input)) {
      return cache[input];
    }
    cache[input] = fn(input);
    return cache[input];
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/memoize.js
// module id = 2171
// module chunks = 37